module.exports = __webpack_public_path__ + "img/settings_black_24dp.86d3a409.svg";